// @flow
import createBoundActionCreators from "common/actionsBase";

export const types = {
	SET_USER_ALLOWED_CAMERA: "SET_USER_ALLOWED_CAMERA",
	SET_CAMERA_NOT_FOUND: "SET_CAMERA_NOT_FOUND",
	SET_CAMERA_LOADING: "SET_CAMERA_LOADING",
};


export default createBoundActionCreators(types, {});
